import { IAdapter, Adapter } from '@tencent/workbench';
import { ensureScrollStop } from '@src/slide/infrastructure/module/independent/scroll';

export const SLIDE_ADAPTER = 'slideAdapter';

@Adapter(SLIDE_ADAPTER)
export class SlideAdapter implements IAdapter<any> {
    public cachedDisableItemIds;
    public cachedCurrentSlide;

    public attachEditor(element: HTMLElement) {
        const editorId = 'pages';
        const scrollContainerId = 'slide-list-m-container';
        const editorDom = document.getElementById(editorId);
        const scrollContainerDom = document.getElementById(scrollContainerId);
        if (!editorDom) {
            return undefined;
        }
        // 确保当前无滚动后
        ensureScrollStop(scrollContainerDom).then(() => {
            const preScrollTop = scrollContainerDom?.scrollTop ?? 0;
            element.style.height = '100%';
            element.style.fontSize = '16px';

            // 将列表dom迁移到workbench下
            const workbench = document.getElementById('workbench');
            if (workbench) {
                workbench.style.display = 'block';
            }
            element.appendChild(editorDom);

            // 更换父节点滚动会被重置，恢复滚动距离
            if (scrollContainerDom) {
                scrollContainerDom.scrollTop = preScrollTop;
            }
        });
        return null;
    }

    public setValue() {
        // do nothing
    }

    public requestFocus() {
        // do nothing
    }

    public requestBlur() {
        // do nothing
    }

    public isCaret() {
        // do nothing
        return false;
    }

    public destroy() {
        // do nothing
    }
}
